import ResourceModel from "models/convention-api/ResourceModel"
import ConventionMeetingAvailability from "models/convention-api/v1/ConventionMeetingAvailability"
import moment from "moment-timezone"

export default class ConventionMeetingType extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/convention_meeting_types"

  protected static rels = {
    conventionMeetingAvailability: () => ({
      type: ConventionMeetingAvailability,
      from: "id",
      filterOn: "convention_meeting_type_id",
    }),
  }

  name!: string
  description!: string
  duration_minutes!: number
  convention_provider_id!: string
  deleted_at!: moment.Moment

  conventionMeetingAvailability?: ConventionMeetingAvailability
}
